export default __webpack_public_path__ + "static/media/bg.ceb97650.webp";